export default __webpack_public_path__ + "static/media/stand_6.46341e94.jpg";